import React from 'react';
import { Link } from 'react-router-dom';
import Classes from './AreasServed.module.css';
import { SITE } from '../../../../../data/siteConfig';
import AreaGroups from '../../../../GlobalComp/AreaGroups/AreaGroups';

// Home page section; service pages render the same thing as a rounded gray box (boxed).
export default function AreasServed({ boxed = false }) {
    const content = (
        <>
            <div className="section-head center">
                <div className="eyebrow">Service Areas</div>
                <h2 className="section-title">Serving Palm Beach and Broward Counties</h2>
                <p className="section-lead">
                    Based in Boca Raton, our team covers homes and condos from Lake Worth Beach to Pompano Beach.
                </p>
            </div>

            <AreaGroups />

            <div className={Classes.cta}>
                <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-dark">
                    Book in your city
                </a>
            </div>
            <p className={Classes.note}>
                Don’t see your city? <Link to="/contact-us">Contact us</Link> and we’ll let you know if we can help.
            </p>
        </>
    );

    if (boxed) return <section className={Classes.boxed}>{content}</section>;

    return (
        <section id="service-areas" className={`section section-gray ${Classes.section}`}>
            <div className="container">{content}</div>
        </section>
    );
}
